import axios from "axios";

export default {
    _convertObj(data) {
        const bodyFormData = new FormData();
        Object.keys(data).forEach(key => bodyFormData.append(key, data[key]));
        return bodyFormData;
    },
    getAuthPage() {
        return axios.get('/include/json/auth/page.json')
    },
    auth(data) {
        const defaultDta = {
            AUTH_FORM: 'Y',
            TYPE: 'AUTH',
            USER_REMEMBER: 'Y',
        }
        const ajaxData = this._convertObj(Object.assign(defaultDta, data))
        return axios({
            method: 'post',
            url: '/api/login/',
            data: ajaxData,
            params: {
                'login' : 'yes'
            },
            headers: {'Content-Type': 'multipart/form-data' },
            validateStatus: function (status) {
                return status >= 200 && status <= 302; // not default
            },
        })
    },
    forgot(data) {
        const defaultDta = {
            AUTH_FORM: 'Y',
            TYPE: 'SEND_PWD',
        }
        const ajaxData = this._convertObj(Object.assign(defaultDta, data))
        return axios({
            method: 'post',
            url: '/api/login/',
            data: ajaxData,
            params: {
                'forgot_password' : 'yes'
            },
            headers: {'Content-Type': 'multipart/form-data' }
        })
    },
    registration(data) {
        const defaultDta = {
            AUTH_FORM: 'Y',
            TYPE: 'REGISTRATION',
        }
        const ajaxData = this._convertObj(Object.assign(defaultDta, data))
        return axios({
            method: 'post',
            url: '/api/registration/',
            data: ajaxData,
            headers: {'Content-Type': 'multipart/form-data' },
            validateStatus: function (status) {
                return status >= 200 && status <= 302; // not default
            },
        })
    },
    newPass(data) {
        const defaultDta = {
            AUTH_FORM: 'Y',
            TYPE: 'CHANGE_PWD',
        }
        const ajaxData = this._convertObj(Object.assign(defaultDta, data))
        return axios({
            method: 'post',
            url: '/api/login/?change_password=yes',
            data: ajaxData,
            headers: {'Content-Type': 'multipart/form-data' }
        })
    }
}